/* ══════════════════════════════════════════════════════════
   Collection Car Title — transform "BMW/A1/2010" into
   a modern styled badge using the correct values from
   the Part Finder search (stored in localStorage).
   ══════════════════════════════════════════════════════════ */

(function () {
  function getCarData() {
    /* Read from localStorage (set by year-make-model.js on search) */
    var brand = localStorage.getItem('Selected-brand');
    var model = localStorage.getItem('Selected-model') || localStorage.getItem('Selected-modle');
    var year = localStorage.getItem('Selected-year');

    if (brand && model) {
      return { brand: brand, model: model, year: year || '' };
    }

    return null;
  }

  function transformTitle(raw) {
    if (!raw || raw.dataset.transformed) return;
    raw.dataset.transformed = 'true';

    /* Prefer localStorage values (accurate), fall back to span text */
    var car = getCarData();
    var brand, model, year;

    if (car) {
      brand = car.brand;
      model = car.model;
      year = car.year;
    } else {
      var text = raw.textContent.trim();
      if (!text) return;

      var parts = text.split('/');
      if (parts.length < 2) return;

      brand = parts[0].trim();
      model = parts[1].trim();
      year = parts[2] ? parts[2].trim() : '';
    }

    var badge = document.createElement('div');
    badge.className = 'collection-car-title';

    badge.innerHTML =
      '<span class="collection-car-title__brand">' + escapeHtml(brand) + '</span>' +
      '<span class="collection-car-title__model">' + escapeHtml(model) + '</span>' +
      (year
        ? '<span class="collection-car-title__divider"></span>' +
          '<span class="collection-car-title__year">' + escapeHtml(year) + '</span>'
        : '');

    raw.parentNode.insertBefore(badge, raw);
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function tryTransform() {
    var el = document.querySelector('.sub_heading_collection_title');
    if (el) transformTitle(el);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryTransform);
  } else {
    tryTransform();
  }

  var observer = new MutationObserver(function () {
    var el = document.querySelector('.sub_heading_collection_title:not([data-transformed])');
    if (el) transformTitle(el);
  });

  observer.observe(document.body || document.documentElement, {
    childList: true,
    subtree: true
  });
})();
